import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { SuccessBadges } from 'components/misc'
import { meta } from 'helpers/decorators'

@meta({
  title: 'Registration completed',
  intlKey: 'pageTitle.registration_complete'
})
class AwardUnitSuccess extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <h1 className="beta">
            <span
              className="ico ico--checked"
              style={{ position: 'relative', top: 5, paddingRight: 15 }}
            />
            <FormattedMessage
              id="moduleTitle.your_registration_is_complete"
              defaultMessage="Your registration is complete"
            />
          </h1>
          <p className="desc">
            <FormattedMessage
              id="label.we_will_send_you_an_email"
              defaultMessage="We will send you an email when your ORB account registration is approved."
            />
          </p>
          <p className="desc">
            <FormattedMessage
              id="label.if_you_have_any_problems_or_doubts"
              defaultMessage="If you have any problems or doubts please contact you award unit for more information."
            />
          </p>
          <SuccessBadges isAwardStaff={true} />
        </div>
      </div>
    )
  }
}

export default AwardUnitSuccess
